module.exports = __webpack_public_path__ + "static/media/regular.f73007b6.png";